import { COLORS } from "utils/styles";
import React from "react";
import styled from "styled-components";

const InfoContainer = styled.div``;

const Title = styled.a.attrs(() => ({
  className: "mabry-medium",
}))`
  font-style: normal;
  font-weight: 500;
  text-decoration: none;
  color: ${COLORS.BLACK};
  font-size: 16pt;
  line-height: 1;

  &:hover,
  &:focus {
    color: ${COLORS.BLACK};
  }
`;

const Subtitle = styled.div.attrs(() => ({
  className: "mabry-light",
}))`
  color: ${COLORS.MEDIUM_GRAY};
  font-style: normal;
  font-weight: normal;
  font-size: 12pt;
  line-height: 1.2;
  margin-top: 5px;
`;

export default function PostInfo(props) {
  const { href, url, title, subtitle } = props;

  return (
    <InfoContainer>
      {href ? (
        <Title target="blank" href={href} src={url}>
          {title}
        </Title>
      ) : (
        <Title src={url}>{title}</Title>
      )}

      <Subtitle>{subtitle}</Subtitle>
    </InfoContainer>
  );
}
